import React, { useState } from 'react'
import { Link } from 'react-router-dom';

import email from './../Images/email.png';




// import Sonnet from '../../components/Sonnet';
function ForgotPasswordEmail() {


    return (
        <>

            <div className="doc-area">
                <div className="container h-100">
                    <div className="doc-box">
                        <div className="doc-inner">

                            <div className="max-600 mb-5 pt-3">
                                <div class="frgt-logo text-center mb-3">
                                    <img src={email} width={120}  alt="" />
                                </div>

                                <div class="frgt-title text-center">
                                    <h3 className='mb-3'>We have sent you an email. 📩</h3>
                                    <p>Check your inbox to continue. If you still need help, <Link to="/contact">contact our support team</Link>.</p>
                                </div>
                               
                            </div>
                        </div>
                    </div>

                </div>
            </div>



        </>
    )
}

export default ForgotPasswordEmail